import { settings as formSettings } from "@hex-insights/forms";
import { Upload } from "@hex-insights/uploads";

export const projectName = process.env.REACT_APP_PROJECT_NAME ?? ""; // Must match that in the server's settings
export const mainServerAppName = "Main Server";
export const jwtIssuer = `${projectName}: ${mainServerAppName}`;

export const applicationDetails = {
	portal: null as "portal" | null,
};

const uploadServerBaseURL = process.env.REACT_APP_UPLOAD_SERVER_BASE_URL;
if (uploadServerBaseURL) {
	formSettings.uploads.url = uploadServerBaseURL + Upload.paths.multipartUpload;
}
const uploadsDomainName = process.env.REACT_APP_UPLOADS_DOMAIN_NAME;
if (uploadsDomainName) {
	formSettings.uploads.bucketRegion = "eu-central-1";
	formSettings.uploads.hostURL = `https://${uploadsDomainName}`;
}

export const uploadsReforgeURL = process.env.REACT_APP_UPLOADS_REFORGE_URL ?? "";
export const uploadsBucketName = process.env.REACT_APP_UPLOADS_BUCKET_NAME ?? "";
if (uploadsBucketName) {
	formSettings.uploads.bucketName = uploadsBucketName;
}

formSettings.uploads.uploadOptions.useTransferAcceleration = true;
